module.exports = __webpack_public_path__ + "application/templates/default/inner/module-people/module-people.template.html";